import { Provider } from "react-redux";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoListInCompleted from "./components/TodoListInCompleted";
import TodoListCompleted from "./components/TodoListCompleted";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div className="grid place-items-center bg-blue-100 h-full px-6 font-sans">
        <Navbar />

        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-20">
          <Header />

          <hr className="mt-4" />

          <TodoListInCompleted status="InCompleted" />

          <hr className="mt-4" />

          <Footer />
        </div>

        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white my-4">
          <div className="">
            <p>List of Completed Task</p>
          </div>
          <hr className="mt-4" />
          <TodoListCompleted status="Completed" />
          <hr className="mt-4" />
        </div>
      </div>
    </Provider>
  );
}

export default App;
